import styled from 'styled-components';

export const StepperMobileStyled = styled.div`
  margin-bottom: 20px;

  .disabled {
    filter: grayscale(1);
  }
`;
